import { CURRENCY } from '@constants/common.constants';
import { get } from './api.service';
import { BIZ_BASE_URL } from '@constants/api.constants';

const endpointBiz = BIZ_BASE_URL;

export const getMilesConversionRate = (currencyCode: string = CURRENCY.SGD) => {
	return get(`${endpointBiz}/conversion-rates/krispay-miles?currencyCode=${currencyCode}`);
};
